import { BlogPost } from '../blog';

import { PublicPost } from './post';

export default function Post() {
  const pub = PublicPost();

  return <BlogPost {...pub} />;
}
